<template>
  <form name="users-history-form" @submit.prevent="$emit('save')">
    <BLayoutExpansion title="Основное" class="my-4">
      <v-row dense>
        <v-col cols="12">
          <BTextField
            v-model="form.user.username"
            validate="required"
            label="Имя пользователя"
            :disabled="isView"
            :skeleton="skeleton"
            name="user.username"
            autofocus
          />
        </v-col>

        <v-col cols="12">
          <BTextarea
            v-model="form.user.full_name"
            validate="required"
            label="ФИО пользователя"
            :disabled="isView"
            :skeleton="skeleton"
            :rows="1"
            name="user.full_name"
          />
        </v-col>

        <v-col cols="12">
          <BTextarea
            :value="userData"
            label="user_data"
            :disabled="isView"
            :skeleton="skeleton"
            name="user_data"
          />
        </v-col>
      </v-row>

      <v-row v-if="!isCreate" dense>
        <v-col cols="auto">
          <BTextField
            :value="data.created_at | dateFormatter"
            :skeleton="skeleton"
            label="Создан"
            disabled
          />
        </v-col>
      </v-row>
    </BLayoutExpansion>

    <button type="submit" class="d-none" />
  </form>
</template>

<script>
import BLayoutForm from '@/components/layouts/BLayoutForm.vue'
import BLayoutExpansion from '@/components/layouts/BLayoutExpansion.vue'
import BTextField from '@/components/forms/BTextField.vue'
import BTextarea from '@/components/forms/BTextarea.vue'


const createDefaultData = () => ({
  // id
  created_at: '',
  user_data: '',
  user: {
    // id
    username: '',
    full_name: '',
  },
})

export default {
  name: 'UsersHistoryForm',
  components: {
    BLayoutExpansion,
    BTextField,
    BTextarea,
  },
  extends: BLayoutForm,
  props: {
    skeleton: Boolean,
    data: {
      type: Object,
      required: true,
      default: createDefaultData,
    },
  },
  computed: {
    userData() {
      const data = this.form.user_data

      try {
        return JSON.stringify(JSON.parse(data), null, 4)
      } catch {
        return data
      }
    },
  },
}
</script>
